import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Users, Calendar, ChevronRight, Sparkles } from 'lucide-react';

const CustomizeExperience = () => {
  return (
    <section className="py-12 sm:py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
          {/* Content */}
          <div className="mb-10 lg:mb-0">
            <div className="inline-flex items-center bg-ta-green/10 rounded-full px-2.5 py-0.5 text-[10px] sm:text-xs text-ta-green mb-4">
              <Sparkles className="h-3 w-3 mr-1" />
              Personalized Experience
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Customize Your Ugandan Adventure –
              <span className="text-ta-green"> Your Journey, Your Way!</span>
            </h2>
            
            <p className="text-sm sm:text-base text-gray-600 mb-8">
              Design your perfect safari experience! Choose your own guide, pick your favorite wildlife and cultural activities, 
              and craft an adventure tailored just for you. Whether it's gorilla trekking, city tours, or adrenaline-packed 
              activities, the choice is yours!
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-ta-green/10 rounded-lg flex items-center justify-center">
                  <Users className="h-4 w-4 sm:h-5 sm:w-5 text-ta-green" />
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900">Expert Guides</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Choose from our verified local guides</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-ta-green/10 rounded-lg flex items-center justify-center">
                  <Compass className="h-4 w-4 sm:h-5 sm:w-5 text-ta-green" />
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900">Flexible Activities</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Mix and match your favorite experiences</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-ta-green/10 rounded-lg flex items-center justify-center">
                  <Calendar className="h-4 w-4 sm:h-5 sm:w-5 text-ta-green" />
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900">Your Timeline</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Travel at your own pace</p>
                </div>
              </div>
            </div>
            
            <Link 
              to="/customize-adventure"
              className="inline-flex items-center px-4 sm:px-6 py-2 sm:py-3 bg-ta-green text-white text-sm sm:text-base rounded-lg hover:bg-ta-green-dark transition-all duration-300 transform hover:translate-y-[-2px] group"
            >
              Start Customizing
              <ChevronRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          
          {/* Image Grid */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-ta-green/20 to-transparent rounded-2xl transform -rotate-3 scale-105"></div>
            <div className="relative grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://imgur.com/LUalhrs.jpg" 
                    alt="Gorilla Trekking" 
                    className="w-full h-32 sm:h-48 object-cover"
                  />
                </div>
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://imgur.com/tzBxU2P.jpg" 
                    alt="White Water Rafting" 
                    className="w-full h-24 sm:h-32 object-cover"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://imgur.com/4kwMnNu.jpg" 
                    alt="Cultural Experience" 
                    className="w-full h-24 sm:h-32 object-cover"
                  />
                </div>
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://imgur.com/WqH4Bly.jpg" 
                    alt="Safari Experience" 
                    className="w-full h-32 sm:h-48 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomizeExperience;